// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { createContext } from 'react'

const modalContext = createContext()

export default modalContext
